<div class="grid-controls-section clearfix">
    <div class="filters" data-region="filters"></div>
    <div class="grid-view-controls">
        <div class="grid-saved-views" data-region="savedViews"></div>
        <div class="toggleButtons" data-region="toggleButtons"></div>
    </div>
</div>
<div class="multiColumnSort" data-region="multiColumnSort"></div>
<div data-region="filterBadges"></div>
<div class="pager" data-region="pager"></div>
